import * as React from 'react'
import Svg from '../Svg'
export const SvgStationPws = (props: React.SVGProps<SVGSVGElement>) => (
    <Svg
        id="station-pws_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 50 50"
        xmlSpace="preserve"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        {...props}
    >
        <style>{'.station-pws_svg__st1{fill:#fff}'}</style>
        <circle cx={25} cy={25} r={25} fill="#30a444" />
        <path
            className="station-pws_svg__st1"
            d="M40.6 20.4l-1-.5c-.1-.1-.4-.1-.5-.1H21.9c-.2 0-.4-.1-.5-.1l-8.5-7c-.1-.1-.4-.1-.5-.1H7.5c-.2 0-.2.1-.2.3l3.3 8.3c.1.1.2.3.4.3h28c.2 0 .4-.1.5-.1l1-.5c.2-.3.2-.5.1-.5z"
        />
        <path
            className="station-pws_svg__st1"
            d="M28.3 19.1l-.2-.4c0-.1-.1-.2-.2-.2h-4.3c-.1 0-.2.1-.2.2l-.2.4v.2h5.2c-.1-.1-.1-.1-.1-.2zM33.9 24.3c-2.1 0-3.8 1.5-4.2 3.5H28l-.2 1.5h1.8c.4 2 2.1 3.5 4.2 3.5 2.3 0 4.2-1.9 4.2-4.2.1-2.4-1.8-4.3-4.1-4.3zM17.6 24.3c2.1 0 3.8 1.5 4.2 3.5h1.7l.2 1.5h-1.8c-.4 2-2.1 3.5-4.2 3.5-2.3 0-4.2-1.9-4.2-4.2-.1-2.4 1.8-4.3 4.1-4.3zM23.1 21.7l2.4 19.4c0 .2.1.3.3.3.2 0 .3-.1.3-.3l2.4-19.4h-5.4z"
        />
    </Svg>
)
SvgStationPws.isIcon = true
export default SvgStationPws
